import PropTypes from 'prop-types';

const ExpandMore = ({stroke}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M6 9L12 15L18 9" stroke={stroke || '#777979'} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
};
ExpandMore.propTypes = {
  stroke: PropTypes.string,
};
export default ExpandMore;